import React from 'react';
import SectionKeepAlive from '../SectionKeepAlive';
import ViewErrorBoundary from '../ViewErrorBoundary';
import HomePage from '../../pages/HomePage';

export default function HomeRouteKeepAlive({ active, enabled }) {
  if (!enabled) return null;
  return (
    <SectionKeepAlive name="home" active={active} enabled={enabled}>
      <ViewErrorBoundary viewName="home">
        <HomePage />
      </ViewErrorBoundary>
    </SectionKeepAlive>
  );
}
